import { Box, Button, Chip, Divider, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink} from 'react-router-dom';
import { useAuthEffects } from '../../components/Auth';
import PageWrapper from '../../components/PageWrapper';
import { useQuickOrdersListQuery } from '../../services/quickOrders';
import { SimpleList } from '../../components/SimpleList';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { CloudDownload as CloudDownloadIcon } from '@mui/icons-material';
import { CURRENCY_SYMBOLS } from '../../types';

const QuickOrdersListView = () => {
	useAuthEffects();

	const { data: shoppingLists = [], isLoading: isShoppingListsLoading, error: shoppingListsError } = useQuickOrdersListQuery();
	const isEmptyView = !shoppingLists.length;

	return <PageWrapper disableFooter={isEmptyView} noScroll={isEmptyView} isLoading={isShoppingListsLoading} maxWidth='md' error={shoppingListsError}>
		{isEmptyView && <Box flex={1} display='flex' alignItems='center' justifyContent='center' flexDirection='column' gap={4}>
			<Typography textAlign='center' fontSize='1.2rem'>You haven&apos;t created any build kits yet. <br/> Check the <strong>supplies section</strong> on each project page to get started.</Typography>
			<Button variant='contained' size='large' component={RouterLink} to='/'>Browse projects</Button>
		</Box>}
		{!isEmptyView && <Box display='flex' flexDirection='column' gap={2} mt={2}>
			<Box display='flex' gap={1}>
				<Typography variant='h6'>My Build Kits</Typography>
				<Chip label={shoppingLists.length} />
			</Box>
			<Typography variant='body2'>These are the projects for which you have created build kits for.</Typography>
			<Divider />
			<SimpleList 
				items={shoppingLists.map((listItem) => ({
					imgUrl: listItem.plan.imgUrl,
					label: listItem.title,
					secondary: `${listItem.products.length} products`,
					component: RouterLink,
					to: `/build-kits/${listItem.id}`,
					properties: [
						...(!listItem.publishedAt ? [{
							el: <Tooltip title='Unpublished'><VisibilityOffIcon color='warning' /></Tooltip>,
						}] : []),
						...(listItem.products.length > 0 && !listItem.products.find((product) => !product.digitalDelivery) ? [{
							el: <Tooltip title='Digital delivery'><CloudDownloadIcon color='success' /></Tooltip>,
						}] : []),
						...(listItem.materialsCost ? [{
							label: `${CURRENCY_SYMBOLS[listItem.vendor.currency]}${listItem.materialsCost}`,
						}] : []),
					],
				}))}
			/>
		</Box>}
	</PageWrapper>;
};

export default QuickOrdersListView;
